<template>
  <div v-if="banner?.pictures && screenWidth >= 768" class="sign-banner">
    <DefPicture :result="banner?.pictures" />
  </div>
</template>

<script lang="ts" setup>
import useScreenWidth from '@use/useScreenWidth';
import DefPicture from '@components/Def/DefPicture/DefPicture.vue';
import { computed } from 'vue';
import { useResultsStore } from '@/storePinia/stores/results';

const resultsStore = useResultsStore();
const screenWidth = useScreenWidth();

type TResult = 'register' | 'auth' | 'change_password';

const props = defineProps<{ result: TResult }>();

const signInBanners = computed(() => resultsStore.signInBanners);

const banner = signInBanners.value?.find((el) => {
  if (el.signInTypeKeys.find((key) => key === props.result)) {
    return true;
  }

  return false;
});
</script>

<style lang="scss" scoped>
.sign-banner {
}
</style>
